import { Icon, SmartText } from '@aibees/shared/components';
import { Box, Stack } from '@mui/material';
import React from 'react';
import * as SX from './sx';
import type { TreeItemLabelBlockProps } from './types';

const EMPTY_TOOLTIP_PROPS = { title: '' } as const;

function TreeItemLabelBlockComponent({ item }: TreeItemLabelBlockProps) {
  return (
    <Stack flexDirection="column" sx={SX.labelWrapper}>
      <Box
        display="flex"
        alignItems="center"
        gap={item.metadata?.secondaryIcon ? 0.5 : 0}
      >
        <SmartText
          variant="body4"
          color={item.disabled ? 'grey.400' : 'grey.700'}
          fontWeight={500}
        >
          {item.label}
        </SmartText>
        {item.metadata?.secondaryIcon && (
          <Box display="flex" alignItems="center" justifyContent="center">
            <Icon
              name={item.metadata?.secondaryIcon}
              size={item.metadata?.secondaryIconSize ?? 16}
              color={item.metadata?.secondaryIconColor ?? 'grey.700'}
            />
          </Box>
        )}
      </Box>

      <Stack
        direction="row"
        alignItems="center"
        gap={0.5}
        paddingBottom={
          item.metadata?.iconSubtitle ||
          item.subtitle ||
          item.metadata?.subtitle
            ? 0.25
            : 0
        }
      >
        {item.metadata?.iconSubtitle && (
          <Icon name={item.metadata?.iconSubtitle} size={12} color="grey.500" />
        )}

        {(item.subtitle || item.metadata?.subtitle) && (
          <SmartText
            variant="body5"
            color="grey.500"
            fontWeight={400}
            tooltipProps={EMPTY_TOOLTIP_PROPS}
          >
            {item.subtitle || item.metadata?.subtitle}
          </SmartText>
        )}
      </Stack>
    </Stack>
  );
}

TreeItemLabelBlockComponent.displayName = 'TreeItemLabelBlock';

export const TreeItemLabelBlock = React.memo(TreeItemLabelBlockComponent);
